require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-project-how-will-a-major-hotel-development-in-a-sensitive-coastal.json") })
        }
      }, "path---en-us-project-how-will-a-major-hotel-development-in-a-sensitive-coastal");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-project-how-will-a-major-hotel-development-in-a-sensitive-coastal!./.cache/json/en-us-project-how-will-a-major-hotel-development-in-a-sensitive-coastal.json
// module id = 525
// module chunks = 231608221292675